import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Measurement ID
// Vervang dit met uw eigen Google Analytics ID (bijv. G-XXXXXXXXXX)
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // TODO: Vervang met uw eigen GA ID

const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialiseer Google Analytics bij eerste load
    if (typeof window !== 'undefined' && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
      // Voeg Google Analytics script toe
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script1);

      // Initialiseer gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [GA_MEASUREMENT_ID, location.pathname, location.search]);

  useEffect(() => {
    // Track page views bij route wijzigingen
    if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, GA_MEASUREMENT_ID]);
};

// Event tracking functie
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Affiliate click tracking
export const trackAffiliateClick = (productName, brand, category) => {
  trackEvent('click', 'Affiliate Link', `${brand} - ${productName}`, category);
};

// Category view tracking
export const trackCategoryView = (categoryName) => {
  trackEvent('view', 'Category', categoryName);
};

// Language switch tracking
export const trackLanguageSwitch = (language) => {
  trackEvent('switch', 'Language', language);
};

export default useGoogleAnalytics;
